export const sidebarNavConfig = {
  items: {
    dashboard: {
      href: "/",
      icon: { style: "far", name: "gauge-high" },
    },
    "dealer-intake": {
      href: "/dealer-intake",
      icon: { style: "far", name: "user-tie" },
    },
    servicepartners: {
      href: "/servicepartners",
      icon: { style: "far", name: "tools" },
    },
    companies: {
      href: "/companies",
      icon: { style: "far", name: "location-dot" },
    },
    affiliates: {
      href: "/affiliates",
      icon: { style: "far", name: "buildings" },
    },
    dossiers: {
      href: "/dossiers",
      icon: { style: "far", name: "clipboard-list" },
    },
    agents: {
      href: "/agents",
      icon: { style: "far", name: "robot" },
    },
    "email-templates": {
      href: "/email-templates",
      icon: { style: "far", name: "envelope" },
    },
    "sms-templates": {
      href: "/sms-templates",
      icon: { style: "far", name: "message-sms" },
    },
    "document-templates": {
      href: "/document-templates",
      icon: { style: "far", name: "receipt" },
      permissions: ["admin_document_template_read"],
    },
    "external-webhooks": {
      href: "/external-webhooks",
      icon: { style: "far", name: "rotate" },
    },
    rules: {
      href: "/rules",
      icon: { style: "far", name: "shuffle" },
    },
    actions: {
      href: "/rules/actions",
      icon: { style: "far", name: "cloud-check" },
    },
    "image-captures": {
      href: "/image-captures",
      icon: { style: "far", name: "image" },
    },
    "image-captures-accounts": {
      href: "/image-captures/accounts",
      icon: { style: "far", name: "user" },
    },
    users: {
      href: "/users",
      icon: { style: "far", name: "user" },
    },
    roles: {
      href: "/users/roles",
      icon: { style: "far", name: "user-tie" },
    },
    permissions: {
      href: "/users/permissions",
      icon: { style: "far", name: "ballot-check" },
    },
    analytics: {
      href: "/analytics",
      icon: { style: "fal", name: "chart-line" },
    },
  },
};
